module.exports = __webpack_public_path__ + "img/slider-v.cf75034a.png";